module.exports = __webpack_public_path__ + "img/slide-6-guide-patients-experiencing.5cc44b36.png";